<ng-template cgp-component-browser-host></ng-template>